export var NativeStreamBloomFilterWriteMode;
(function (NativeStreamBloomFilterWriteMode) {
    NativeStreamBloomFilterWriteMode["NATIVE_STREAM_BLOOM_FILTER_WRITE_MODE_COMPACTION_ONLY"] = "compaction_only";
    NativeStreamBloomFilterWriteMode["NATIVE_STREAM_BLOOM_FILTER_WRITE_MODE_ALWAYS"] = "always";
})(NativeStreamBloomFilterWriteMode || (NativeStreamBloomFilterWriteMode = {}));
